import { render, staticRenderFns } from "./DispatcherVehiclesTab.vue?vue&type=template&id=0b1cdb9c&"
import script from "./DispatcherVehiclesTab.vue?vue&type=script&lang=js&"
export * from "./DispatcherVehiclesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QTh,QTd,QCardSection,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QTh,QTd,QCardSection,QInnerLoading,QSpinnerGears}, component.options.components || {})
